// Sample property-search events for the /leads-property-searches demo/empty
// state. Shape mirrors the /property-report-requests response so the page's
// existing grouping/filtering and card render work unchanged. While these
// render, useDemoNetworkGuard keeps window.__demoMode on and the page disables
// navigation into the (real) detail view, so nothing here touches the backend.

const iso = (daysAgo) =>
  new Date(Date.now() - daysAgo * 86400 * 1000).toISOString();

const img = (id) => `https://images.unsplash.com/${id}?w=400&q=60&auto=format`;

const DEMO_PROPERTY_SEARCHES = [
  {
    property_id: "demo-1",
    email: "sarah.mitchell@example.com",
    contact_full_name: "Sarah Mitchell",
    contact_email: "sarah.mitchell@example.com",
    contact_mobile: "0412 345 678",
    agent_name: "You",
    created_at: iso(0),
    metadata: {
      property_id: "demo-1",
      valuation: 1850000,
      valuation_lower: 1750000,
      valuation_upper: 1950000,
      rental_estimate: 980,
      rental_estimate_lower: 920,
      rental_estimate_upper: 1040,
      request: {
        address_text: "14 Darling Street, Balmain NSW 2041",
        report_type: "property_report",
        property_type: "House",
        bedrooms: 4,
        bathrooms: 2,
        carspaces: 1,
        land_area: 412,
        suburb_id: "Balmain",
        media_urls: [img("photo-1568605114967-8130f3a36994")],
      },
    },
  },
  {
    property_id: "demo-2",
    email: "james.nguyen@example.com",
    contact_full_name: "James Nguyen",
    contact_email: "james.nguyen@example.com",
    contact_mobile: "0423 887 210",
    agent_name: "You",
    created_at: iso(2),
    metadata: {
      property_id: "demo-2",
      valuation: 1240000,
      valuation_lower: 1180000,
      valuation_upper: 1300000,
      rental_estimate: 720,
      rental_estimate_lower: 680,
      rental_estimate_upper: 760,
      request: {
        address_text: "8 Glenferrie Road, Hawthorn VIC 3122",
        report_type: "property_analysis",
        property_type: "Townhouse",
        bedrooms: 3,
        bathrooms: 2,
        carspaces: 2,
        land_area: 260,
        suburb_id: "Hawthorn",
        media_urls: [img("photo-1570129477492-45c003edd2be")],
      },
    },
  },
  {
    property_id: "demo-3",
    email: "priya.sharma@example.com",
    contact_full_name: "Priya Sharma",
    contact_email: "priya.sharma@example.com",
    contact_mobile: "0438 552 901",
    agent_name: "You",
    created_at: iso(6),
    metadata: {
      property_id: "demo-3",
      valuation: 890000,
      valuation_lower: 850000,
      valuation_upper: 930000,
      rental_estimate: 560,
      rental_estimate_lower: 530,
      rental_estimate_upper: 590,
      request: {
        address_text: "22 Sherwood Road, Toowong QLD 4066",
        report_type: "property_report",
        property_type: "Unit",
        bedrooms: 2,
        bathrooms: 1,
        carspaces: 1,
        land_area: null,
        suburb_id: "Toowong",
        media_urls: [img("photo-1512917774080-9991f1c4c750")],
      },
    },
  },
  {
    property_id: "demo-4",
    email: "tom.andersson@example.com",
    contact_full_name: "Tom Andersson",
    contact_email: "tom.andersson@example.com",
    contact_mobile: "0401 229 384",
    agent_name: "You",
    created_at: iso(11),
    metadata: {
      property_id: "demo-4",
      valuation: 2350000,
      valuation_lower: 2200000,
      valuation_upper: 2500000,
      rental_estimate: 1150,
      rental_estimate_lower: 1080,
      rental_estimate_upper: 1220,
      request: {
        address_text: "5 Moseley Street, Glenelg SA 5045",
        report_type: "property_analysis",
        property_type: "House",
        bedrooms: 5,
        bathrooms: 3,
        carspaces: 2,
        land_area: 680,
        suburb_id: "Glenelg",
        media_urls: [img("photo-1564013799919-ab600027ffc6")],
      },
    },
  },
];

export default DEMO_PROPERTY_SEARCHES;
